import { render } from "./CreatingEmployee.vue?vue&type=template&id=08e939a8"
import script from "./CreatingEmployee.vue?vue&type=script&lang=js"
export * from "./CreatingEmployee.vue?vue&type=script&lang=js"
script.render = render

export default script